module.exports = __webpack_public_path__ + "img/prioritas.d077b00b.jpg";